import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <path fill="#1663B7" d="M311.829 209.787H131V172h180.829z" />
      <path stroke="#5CD6EA" strokeWidth="7.229" d="M308.418 183.217H134" />
      <path
        fill="#5CD6EA"
        d="M302.236 195.875H299V184h3.236zM287.236 195.875H284V184h3.236zM273.236 195.875H270V184h3.236zM259.236 195.875H256V184h3.236zM244.236 195.875H241V184h3.236zM230.236 195.875H227V184h3.236zM215.236 195.875H212V184h3.236zM201.236 195.875H198V184h3.236zM187.236 195.875H184V184h3.236zM172.236 195.875H169V184h3.236zM158.236 195.875H155V184h3.236zM143.236 195.875H140V184h3.236z"
      />
      <path
        fill="#1251A0"
        d="M301.922 195.467l-160.877.03L131.157 172H78v37.787h287.85L390.69 172h-78.643l-10.125 23.467"
      />
      <path
        fill="#1663B7"
        d="M78 172.358h50.86V131H97.605L78 156.38zM374.885 171.78H361V157h13.885zM337.885 171.78H324V157h13.885z"
      />
      <path fill="#DDD" d="M270.072 171.883H242V142h28.072z" />
      <path fill="#50A1DA" d="M242.072 171.883H214V142h28.072z" />
      <path fill="#9FD35B" d="M213.072 171.883H185V142h28.072z" />
      <path
        fill="#3281C9"
        d="M291.154 172.519H270v-22.52h21.154zM185.42 172.519H157v-22.52h28.42z"
      />
      <path fill="#7BB934" d="M269.829 141.895h-47.83V124h47.83z" />
      <path fill="#DDD" d="M221.481 141.895h-36.48V124h36.48z" />
      <path
        fill="#5CD6EA"
        d="M126.503 148.793H122V144h4.503zM117.503 148.793H113V144h4.503zM107.503 148.793H103V144h4.503zM98.503 148.793H94V144h4.503z"
      />
      <path fill="#1251A0" d="M121.741 130.482h-5.74V113h5.74z" />
      <ellipse cx="337.93" cy="191.377" fill="#5CD6EA" rx="6.93" ry="7.377" />
      <path fill="#5CD6EA" d="M88 157.445V154h41.205v3.445z" />
      <path fill="#50BFD8" d="M469 277H0v-67h469z" />
      <path
        fill="#63CEE0"
        d="M398.262 225.66H375V223h23.262zM389.262 222.66H366V220h23.262zM413.262 255.66H390V253h23.262zM386.71 255.66H380V253h6.71zM130.262 243.66H107V241h23.262zM104.71 243.66H98V241h6.71zM305.71 241.66H299V239h6.71zM294.71 241.66H288V239h6.71zM87.262 243.66H64V241h23.262zM60.71 243.66H54V241h6.71z"
      />
      <path fill="#B2DBF9" d="M158 55h13.054v2.898H158zM142 52h22.966v2.898H142z" />
      <path
        fill="#D9F2FF"
        d="M91 52h16v3H91zM381 81h16v3h-16zM324 97h9.852v2.355H324zM336 97h4.594v2.355H336z"
      />
    </g>
  </Svg>
)
